import { passwordSchema } from "@/utils/form";
import { z } from "zod";


export const PasswordSchema = z.object({
  password: passwordSchema,
  newPassword: passwordSchema,
  confirmNewPassword: passwordSchema,
}).check((ctx) => {
  if (ctx.value.newPassword !== ctx.value.confirmNewPassword) {
    ctx.issues.push({
      code: "custom",
      message: "New password fields do not match",
      path: ["confirmNewPassword"], // Error will be added to confirmNewPassword field
      input: ctx.value,
    });
  }
});

export const PasswordDefaultValues = {
  password: "",
  newPassword: "",
  confirmNewPassword: "",
};

export type TPasswordSchema = z.infer<typeof PasswordSchema>;
